export const resolveSelectedMenuKeys = (pathname: string, search: string) => {
    const pathWithSearch = `${pathname}${search}`;

    if (pathname === "/Admin/Events/Archive") {
        return ["/Admin/Events/Archive"];
    }

    if (pathname.startsWith("/Admin/Events/")) {
        return ["/Admin/Events"];
    }

    if (pathname.startsWith("/Admin/Hotels/")) return ["/Admin/Hotels"];

    if (pathname.startsWith("/Admin/Payers/")) {
        return ["/Admin/Payers"];
    }

    if (pathname === "/Admin/Events" && new URLSearchParams(search).get("view") === "archived") {
        return ["/Admin/Events/Archive"];
    }

    return search ? [pathWithSearch, pathname] : [pathname];
};
